import React from 'react';
import { TotalsSection } from '@/components/portfolio/build/TotalsSection';

interface PortfolioSummaryProps {
  portfolioSize: number;
  allocations: any[];
  onAutoSize: (targetSize?: number) => Promise<void> | void;
  isPortfolioSizeLocked: boolean;
  mode: 'percentage' | 'dollar';
  overrides: Record<string, number>;
  currency: string;
}

export function PortfolioSummary(props: PortfolioSummaryProps) {
  return (
    <TotalsSection
      portfolioSize={props.portfolioSize}
      allocations={props.allocations}
      onAutoSize={props.onAutoSize}
      isPortfolioSizeLocked={props.isPortfolioSizeLocked}
      mode={props.mode}
      overrides={props.overrides}
      currency={props.currency}
    />
  );
}
